    
import { ApiProperty } from "@nestjs/swagger";
import { SendToEnum } from "@schemax-whatsapp/shared-models";
    
export class CompanyDeptRoleCategoryCodeRequest{
    @ApiProperty()
    companyCode: string;
    @ApiProperty()
    sendTo?:SendToEnum;
    @ApiProperty()
    departmentCode?:string;
    @ApiProperty()
    role?:string;

    constructor(companyCode:string, sendTo?:SendToEnum,departmentId?:string,role?:string){
        this.companyCode = companyCode;
        this.sendTo = sendTo;
        this.departmentCode = departmentId;
        this.role = role;
    }

}


